import { parseCustomAppLaunchSlug } from './myAppsLaunch';
import { HUB_REGISTRY, STANDALONE_APP_REGISTRY } from './registry/hubRegistry';
import { findToolByPath } from './registry/registrySelectors';

export function resolveRecentToolId(
  pathname: string,
  permittedIds: ReadonlySet<string>
): string | null {
  const customSlug = parseCustomAppLaunchSlug(pathname);
  if (customSlug && permittedIds.has(customSlug)) return customSlug;

  const tool = findToolByPath(HUB_REGISTRY, pathname)?.tool;
  const standalone = STANDALONE_APP_REGISTRY.find(
    (app) => pathname === app.path || pathname.startsWith(`${app.path}/`)
  );
  const id = tool?.id ?? standalone?.id;
  return id && permittedIds.has(id) ? id : null;
}
